import { defineMessages } from 'react-intl';

const messages = defineMessages({
  residentLetterTitle: {
    id: 'App.RentForecast.ResidentLetterModal.Title',
    defaultMessage: 'Generate Resident Letter',
  },
  residentLetterDescription: {
    id: 'App.RentForecast.ResidentLetterModal.Description',
    defaultMessage:
      'This letter will pull in the current budget details and the selected reasons. Make sure your budget is up to date before continuing.', // eslint-disable-line max-len
  },
  residentLetterReasonsLabel: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonsLabel',
    defaultMessage: 'Reason(s) for Rent Change',
  },
  residentLetterReasonsHelper: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonsHelper',
    defaultMessage: 'Please select at least one reason.',
  },
  residentLetterReasonsPlaceholder: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonsPlaceholder',
    defaultMessage: 'Select Reason(s)',
  },
  residentLetterReasonMaintenance: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonMaintenance',
    defaultMessage: 'Increase in Maintenance, Grounds, and Building Expenses',
  },
  residentLetterReasonFees: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonFees',
    defaultMessage:
      'Increase in Management Fees and/or Site Management Staff Payroll',
  },
  residentLetterReasonTaxes: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonTaxes',
    defaultMessage: 'Increase in Taxes and/or Insurance',
  },
  residentLetterReasonOther: {
    id: 'App.RentForecast.ResidentLetterModal.ReasonOther',
    defaultMessage: 'Other',
  },
  residentLetterOtherLabel: {
    id: 'App.RentForecast.ResidentLetterModal.OtherLabel',
    defaultMessage: 'Enter reason',
  },
  residentLetterOtherPlaceholder: {
    id: 'App.RentForecast.ResidentLetterModal.OtherPlaceholder',
    defaultMessage: 'Enter reason here...',
  },
  residentLetterCancel: {
    id: 'App.RentForecast.ResidentLetterModal.Cancel',
    defaultMessage: 'Cancel',
  },
  residentLetterGenerate: {
    id: 'App.RentForecast.ResidentLetterModal.Generate',
    defaultMessage: 'Generate',
  },
  residentLetterDownloadSuccess: {
    id: 'App.RentForecast.ResidentLetterModal.DownloadSuccess',
    defaultMessage: 'Resident letter downloaded successfully.',
  },
  residentLetterDownloadError: {
    id: 'App.RentForecast.ResidentLetterModal.DownloadError',
    defaultMessage: 'Error downloading resident letter.',
  },
  residentRegionLabel: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Label',
    defaultMessage: 'Select a Region',
  },
  residentRegionPlaceholder: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Placeholder',
    defaultMessage: 'Select an option',
  },
  residentRegionServiceNorthEast: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Options.NorthEast',
    defaultMessage: 'MFH FOD Northeast',
  },
  residentRegionServiceMidWest: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Options.MidWest',
    defaultMessage: 'MFH FOD Midwest',
  },
  residentRegionServiceSouth: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Options.South',
    defaultMessage: 'MFH FOD South',
  },
  residentRegionServiceWest: {
    id: 'App.RentForecast.ResidentLetterModal.ServiceRegion.Options.West',
    defaultMessage: 'MFH FOD West',
  },
});

export default messages;
